import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import FacebookLoginButton from '../../../../../../common/buttons/FacebookLoginButton/FacebookLoginButton';
import * as allPermissions from '@mm/constants/facebook-permissions';
import { monkeyImage } from '../../../../../../common/constants/assets';
import './FacebookConnectModal.scss';
import * as routes from '../../../../../../common/constants/routes';

type Props = {
  show: boolean;
  message: string;
  hide: (params: any) => any;
  onConnect: (params: {
    facebookToken: string;
    [key: string]: any;
  }) => Promise<void>;
  permissions: string;
};

const FacebookConnectModal = (props: Props) => {
  const { show, message, hide, onConnect, permissions } = props;
  const fbPermissionsObjects = allPermissions[permissions];
  const hideWithRedirect = hide(
    allPermissions.redirectToSignup(fbPermissionsObjects) ? routes.SIGNUP : '',
  );

  return (
    <Modal isOpen={show} toggle={hideWithRedirect} centered>
      <ModalBody className="facebook-connect-modal">
        <img
          src={monkeyImage}
          alt="Mobile Monkey"
          className="facebook-connect-modal__logo"
        />
        <h1 className="facebook-connect-modal__sign-in-text">Sign in</h1>
        <FacebookLoginButton
          askForPermissions
          permissions={permissions}
          onSuccess={onConnect}
        />
        <div className="facebook-connect-modal__message">
          <span>
            Looks like we're missing some of the permissions we need to power
            your Facebook Page's Messenger Marketing. Click the{' '}
            <b>Sign in with Facebook</b> button above to fix it!
          </span>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FacebookConnectModal;
